exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-radio-group-item{display:inline-block;margin-right:45px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormRadioGroup/FormRadioGroup.scss
 ** module id = 1245
 ** module chunks = 0
 **/